import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthCtx = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [church, setChurchRaw] = useState(null);
  const setChurch = useCallback((c) => setChurchRaw((prev) => (c && prev && !c.dashboard_theme ? { ...c, dashboard_theme: prev.dashboard_theme, public_theme_state: c.public_theme_state || prev.public_theme_state } : c)), []);
  const [loading, setLoading] = useState(true);
  const [isAdmin, setIsAdmin] = useState(false);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      const [c, a] = await Promise.all([api.get("/church"), api.get("/admin/me")]);
      setChurch(c.data);
      setIsAdmin(a.data.is_admin);
    } catch {
      setUser(null);
      setChurch(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    // Skip /me while returning from OAuth; AuthCallback establishes the session first.
    if (window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    refresh();
  }, [refresh]);

  const logout = async () => {
    await api.post("/auth/logout");
    setUser(null);
    setChurch(null);
  };

  return (
    <AuthCtx.Provider value={{ user, church, loading, isAdmin, setChurch, refresh, logout }}>
      {children}
    </AuthCtx.Provider>
  );
};

export const useAuth = () => useContext(AuthCtx);
